import { Box, Card, CardContent, CardHeader, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { useStatisticsContext } from '../contexts/StatistiquesProvider';
import style from '../../../features/statistiques/css/Statistics.module.scss';
import { cumulData } from 'core/utils/utils';
import classNames from 'classnames';

type Props = {};

const TableEffectifsMoyens: React.FC<Props> = () => {
    const { effectifsMoyens, isLoadingEffectifsMoyens } = useStatisticsContext();

    let data = [];
    let dataCoef = null;
    let hasData_N = true;
    let hasData_N_1 = true;
    if (effectifsMoyens.length > 1) {
        //TODO :: calculate benefici position using LB_REGROUPLIEN and replace data[3] by index

        // TODO  :: remove data and use map.filter to exclude cumul benefici
        // Calcule position cumul benefici (à positionner à l'avant dernière ligne du tableau)
        // const positionCumulBenefi = effectifsMoyens.length - 1;

        // Reorder data (Cumul benefi est en premier ligne dans le retour API)
        // TODO use pop !
        data.push(effectifsMoyens[1]);
        data.push(effectifsMoyens[2]);
        data.push(effectifsMoyens[3]);
        data.push(effectifsMoyens[0]);

        // array of data to calculate (tout sauf cumul benefici)
        let values = [...data].slice(0, -1);

        // Replace null value by zero + defined if year has result
        const dataVerified = [];
        values.forEach((e) => {
            if (e) {
                dataVerified.push(e);
            } else {
                dataVerified.push({
                    LB_REGROUPLIEN: '',
                    NUM_Effectifs_N: 0,
                    NUM_POIDS_N: '.00',
                    Coefficient_familial_N: null,
                    NUM_Effectifs_N_1: 0,
                    NUM_POIDS_N_1: '.00',
                    Coefficient_familial_N_1: null,
                    Evolution: '0',
                });
            }
        });

        values = dataVerified;

        // Calcul % cumul bénéficaires
        const cumulPourcentageN_1 = values.map((e) => e.NUM_POIDS_N_1).reduce(cumulData, 0);
        const cumulPourcentageN = values.map((e) => e.NUM_POIDS_N).reduce(cumulData, 0);
        const cumulEvolution = data[3]['Evolution'];

        data[3]['NUM_POIDS_N_1'] = cumulPourcentageN_1;
        data[3]['NUM_POIDS_N'] = cumulPourcentageN;
        data[3]['Evolution'] = cumulEvolution;

        // Add Coefficient familial data
        dataCoef = {
            LB_REGROUPLIEN: 'Coefficient familial',
            coef_n_1: values
                .map((e) => e.Coefficient_familial_N_1)
                .filter((e) => e)
                .reduce(cumulData, 0), // coef N_1
            coef_n: values
                .map((e) => e.Coefficient_familial_N)
                .filter((e) => e)
                .reduce(cumulData, 0), // coef N
        };
    }

    // remove empty entry
    data = data.filter((e) => e);

    return (
        <Card className="w-100" style={{ boxShadow: 'none' }}>
            <CardHeader title="Effectifs moyens" className={style.graphsTitle} />
            <CardContent className={classNames(style.chartBox, style.tableMargin)}>
                <Box className={style.graphsDivider} style={{ maxWidth: '552px' }}></Box>
                {!isLoadingEffectifsMoyens ? (
                    <>
                        <TableContainer component={Paper} className={style.tableNoBorder}>
                            <Table className={style.tableEffectifsMoyens}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell align="center" colSpan={2} className={classNames(style.cellBlue, style.cellBold, style.bigger)}>
                                            Survenance <br />
                                            Excercice N-1
                                        </TableCell>
                                        <TableCell align="center" colSpan={2} className={classNames(style.cellBlue, style.cellBold, style.bigger)}>
                                            Survenance <br />
                                            Excercice N
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell align="center" className={classNames(style.cellSkyBlue, style.cellBold, style.bigger)}>
                                            Effectifs
                                        </TableCell>
                                        <TableCell align="center" className={classNames(style.cellSkyBlue, style.cellBold, style.bigger)}>
                                            %
                                        </TableCell>
                                        <TableCell align="center" className={classNames(style.cellSkyBlue, style.cellBold, style.bigger)}>
                                            Effectifs
                                        </TableCell>
                                        <TableCell align="center" className={classNames(style.cellSkyBlue, style.cellBold, style.bigger)}>
                                            %
                                        </TableCell>
                                        <TableCell align="center" className={classNames(style.cellBlue, style.cellBold)}>
                                            Evolution
                                        </TableCell>
                                    </TableRow>
                                    {data.map((row, index) => (
                                        <TableRow key={index} hover className={classNames(index === 3 ? style.cellBold : '')}>
                                            <TableCell scope="row" className={classNames(isOdd(index) ? style.cellLightGray : style.cellGray, cellBold(index))}>
                                                <strong>{row.LB_REGROUPLIEN}</strong>
                                            </TableCell>
                                            <TableCell align="center" className={classNames(cellClass(index), cellBold(index))}>
                                                {displayStrong(index, hasData_N ? row.NUM_Effectifs_N_1 : '-')}
                                            </TableCell>
                                            <TableCell align="center" className={classNames(cellClass(index), cellBold(index))}>
                                                {displayStrong(index, hasData_N ? (row.NUM_POIDS_N_1 ? (parseFloat(row.NUM_POIDS_N_1) * 100).toFixed(0) + '%' : '0.0%') : '-')}
                                            </TableCell>
                                            <TableCell align="center" className={classNames(cellClass(index), cellBold(index))}>
                                                {displayStrong(index, hasData_N_1 ? row.NUM_Effectifs_N : '-')}
                                            </TableCell>
                                            <TableCell align="center" className={classNames(cellClass(index), cellBold(index))}>
                                                {displayStrong(index, hasData_N_1 ? (row.NUM_POIDS_N ? (parseFloat(row.NUM_POIDS_N) * 100).toFixed(0) + '%' : '0') : '-')}
                                            </TableCell>
                                            <TableCell align="center" className={classNames(cellClass(index), cellBold(index))}>
                                                {displayStrong(index, hasData_N_1 && hasData_N ? (row.Evolution ? (parseFloat(row.Evolution) * 100).toFixed(1) + '%' : '0.0%') : '-')}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {dataCoef && (
                                        <TableRow>
                                            <TableCell scope="row">{dataCoef.LB_REGROUPLIEN}</TableCell>
                                            <TableCell align="center">{dataCoef.coef_n_1 ? parseFloat(dataCoef.coef_n_1).toFixed(2) : ''}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell align="center">{dataCoef.coef_n ? parseFloat(dataCoef.coef_n).toFixed(2) : ''}</TableCell>
                                            <TableCell> </TableCell>
                                            <TableCell> </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ) : (
                    'Loading...'
                )}
            </CardContent>
        </Card>
    );
};

export default TableEffectifsMoyens;

const isOdd = function (x) {
    return x & 1;
};

const cellClass = (index) => {
    return classNames(isOdd(index) && index < 3 ? style.cellGray : index < 3 ? '' : style.cellLightGray);
};

const cellBold = (index) => {
    return classNames(index === 3 ? style.cellBold : '');
};

const displayStrong = (index, value) => {
    return index === 3 ? <strong>{value}</strong> : value;
};
